import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useSelector } from 'react-redux';
import ManhattanScrollablePlot from 'Shared/plots/components/ManhattanPlot/ManhattanScrollablePlot';
import { Legend } from 'Shared/plots/components/ManhattanPlot/components/Legend';
import { ETraitsTypes } from 'Shared/types';
import { MANHATTAN_PLOT_AXIS_CONFIG, MANHATTAN_PLOT_LOWER_THRESHOLD_CONFIG, MANHATTAN_PLOT_UPPER_THRESHOLD_CONFIG, } from 'Common/consts/plot';
import { getManhattanPlotLegendConfig } from 'Common/utils';
import { getTraitsType } from 'PhenotypeView/store/selectors';
import { getPlotData } from 'PhenotypeView/store/selectors/levelResults/plr/plr';
export const ManhattanPlotContainer = memo(function ManhattanPlotContainer({ useBinaryPlotTooltip, useContinuousPlotTooltip, getBinaryPlotDataPointShape, getContinuousPlotDataPointShape, }) {
    const traitsType = useSelector(getTraitsType);
    const plotData = useSelector(getPlotData);
    const plotTooltipFactory = (traitsType === ETraitsTypes.Binary)
        ? useBinaryPlotTooltip
        : useContinuousPlotTooltip;
    const getPlotDataPointShape = (traitsType === ETraitsTypes.Binary)
        ? getBinaryPlotDataPointShape
        : getContinuousPlotDataPointShape;
    const getTooltipContent = plotTooltipFactory({});
    const legendConfig = getManhattanPlotLegendConfig(traitsType);
    return (_jsx(ManhattanScrollablePlot, { data: plotData, axis: MANHATTAN_PLOT_AXIS_CONFIG, upperThreshold: MANHATTAN_PLOT_UPPER_THRESHOLD_CONFIG, lowerThreshold: MANHATTAN_PLOT_LOWER_THRESHOLD_CONFIG, getTooltipContent: getTooltipContent, getDataPointShape: getPlotDataPointShape, legend: _jsx(Legend, { labelsConfig: legendConfig }, void 0) }, void 0));
});
